var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"welcome-section"},[_c('HomeSlider',{attrs:{"sliders":_vm.slides}})],1),_c('div',{staticClass:"intro-section"},[_c('HomeIntroduction')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }